var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#AAA6A6",
    strokeWidth: 1.5,
    d: "M19 9c0 5.076-5.243 11.103-6.654 12.633a.466.466 0 0 1-.692 0C10.243 20.103 5 14.077 5 9c0-3.866 2.582-7 7-7s7 3.134 7 7Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 2.5,
    stroke: "#AAA6A6",
    strokeWidth: 1.5
  })));
};
export default SvgMap;